import * as React from "react";

function LoadingLine() {
    return (
        <div className="tmp-indeterminate-progress" role="progressbar">
            <div className="tmp-indeterminate-progress-bar tmp-indeterminate-progress-bar1"></div>
            <div className="tmp-indeterminate-progress-bar tmp-indeterminate-progress-bar2"></div>
        </div>
    );
}

export default LoadingLine;
